import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';

import { setClassNames } from '../utils/utility';

const PricingSummaryLink = ({
	label,
	labelFontSize,
	isCalculatePayment,
	viewPriceDetail
}) => {
	const calcPaymentClasses = isCalculatePayment
		? ['calculate-payment-integrated', 'calculate-payment-scroll-up']
		: [];

	if (label) {
		return (
			<button
				onClick={!isCalculatePayment ? viewPriceDetail : null}
				className={setClassNames(
					'text-link',
					'text-left',
					'd-block',
					'line-height-reset',
					labelFontSize,
					...calcPaymentClasses
				)}
			>
				<Common
					render={({ labels }) => {
						return labels.get(label);
					}}
				/>
			</button>
		);
	}
	return null;
};

PricingSummaryLink.propTypes = {
	label: PropTypes.string.isRequired,
	labelFontSize: PropTypes.string,
	isCalculatePayment: PropTypes.bool,
	viewPriceDetail: PropTypes.func
};

PricingSummaryLink.defaultProps = {
	labelFontSize: '',
	isCalculatePayment: false,
	viewPriceDetail: () => {}
};

export default PricingSummaryLink;



// WEBPACK FOOTER //
// ./src/components/PricingSummaryLink.jsx